export const filterOptions = [
  {
    key: 'monitoring_type',
    label: 'DYNAMIC_FILTER.MONITORING_TYPE_KEY',
    isSelect: true,
    selectType: [
      {
        key: 'type_instances_operational_timing',
        label: 'DYNAMIC_FILTER.OPERATING_TIME_KEY',
      },
      {
        key: 'scale_instances_timeout_sessions',
        label: 'BLOCK_INSTANCES_WITH_SESSIONS_TIMEOUT_KEY',
      },
    ],
  },
];
